var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 311,
    viewBox: "0 0 406 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip0_3508_3639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4018 112.382C99.7245 106.019 138.712 108.844 175.27 118.28L180.988 73.1489C144.421 63.7131 105.433 60.8885 68.0897 67.2411L62.3915 112.382H62.4018Z",
    stroke: "url(#paint0_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.753 237.491C54.7801 229.348 17.9434 215.422 -0.991961 187.777C-15.3254 166.846 -8.38617 144.778 11.7282 130.851C26.5786 120.577 44.7901 115.425 62.3914 112.383L68.0896 67.2422C43.2389 71.5256 7.53982 81.6546 -1.70553 108.679C-10.3614 133.976 13.7654 155.952 32.8249 168.005C50.7468 179.345 71.0163 186.908 91.4616 192.257L85.7427 237.47L85.753 237.491Z",
    stroke: "url(#paint1_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2457 265.787C55.8142 263.252 32.7525 252.585 47.0446 240.822C56.7656 232.814 74.5738 234.645 85.7634 237.49L91.4822 192.277C80.303 189.431 62.4845 187.6 52.7531 195.598C38.4714 207.351 61.5331 218.029 70.9646 220.553L65.2561 265.787H65.2457Z",
    stroke: "url(#paint2_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-65.7714 129.559C-102.225 183.308 -27.063 230.818 14.2619 248.552C30.767 255.639 47.8823 261.247 65.2457 265.789L70.9543 220.555C22.2662 207.87 -55.4712 180.142 -68.0569 123.868C-71.1594 109.994 -68.0673 96.0781 -60.1043 84.3867L-65.7714 129.548V129.559Z",
    stroke: "url(#paint3_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 89.6219C127.006 72.9747 49.4128 68.5671 -15.5632 93.9777C-34.6537 101.437 -53.8786 112.342 -65.7714 129.559L-60.1042 84.397C-40.2174 55.6342 -1.85025 43.6532 30.9118 37.4247C63.6739 31.1962 100.438 30.2444 135.041 33.5138C156.665 35.552 178.145 39.225 199.21 44.5223L193.481 89.6322V89.6219Z",
    stroke: "url(#paint4_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.907 88.6506L190.72 89.0851L196.439 43.9752C187.69 42.475 161.484 40.654 158.682 54.2077C156.417 65.1437 173.294 70.9584 180.988 73.1621L175.27 118.293C167.7 116.12 151.494 110.637 152.828 100.083C154.514 86.7262 179.468 87.5642 187.907 88.6609V88.6506Z",
    stroke: "url(#paint5_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.72 89.0826L193.481 89.6206L199.21 44.5107L196.439 43.9727L190.72 89.0826Z",
    stroke: "url(#paint6_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.439 43.9735L199.2 44.5116C136.685 28.8576 66.5591 24.8432 4.28229 43.9322C-24.219 52.6645 -60.0112 69.5186 -67.9225 101.396C-75.5442 132.072 -51.1691 159.149 -28.5211 176.065C0.704105 197.906 35.8964 211.408 70.9439 220.554C61.5124 218.03 38.4404 207.352 52.7325 195.599C62.4639 187.591 80.272 189.432 91.4616 192.278C59.0822 183.794 -2.01572 162.242 -3.47388 120.412C-4.93204 78.582 57.0139 67.4183 86.994 64.8421C118.432 62.1313 150.471 65.2663 180.978 73.1605C173.284 70.9567 156.396 65.1525 158.671 54.2061C161.484 40.6524 187.679 42.463 196.428 43.9735H196.439Z",
    stroke: "url(#paint7_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 89.6228C184.236 87.6467 157.244 84.9049 153.17 98.5931C149.819 109.86 167.472 116.068 175.27 118.292C127.202 105.856 66.5591 101.79 20.9942 125.359C7.15722 132.519 -7.03139 144.179 -8.95492 160.681C-10.8785 177.184 0.455894 191.938 12.2349 202.242C32.7939 220.214 59.682 230.653 85.7634 237.492C74.5842 234.647 56.776 232.816 47.0446 240.824C32.7629 252.577 55.8039 263.265 65.2458 265.79C34.3245 257.709 3.71348 246.256 -23.2573 228.874C-47.5703 213.21 -76.144 188.047 -74.9547 156.232C-73.7138 122.917 -39.7314 102.825 -12.016 92.6336C16.2578 82.2355 46.7344 78.0142 76.7145 76.99C115.95 75.6449 155.424 80.0732 193.481 89.6228V89.6228Z",
    stroke: "url(#paint8_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4018 112.382C99.7245 106.019 138.712 108.844 175.27 118.28L180.988 73.1489C144.421 63.7131 105.433 60.8885 68.0897 67.2411L62.3915 112.382H62.4018Z",
    stroke: "url(#paint9_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.753 237.491C54.7801 229.348 17.9434 215.422 -0.991961 187.777C-15.3254 166.846 -8.38617 144.778 11.7282 130.851C26.5786 120.577 44.7901 115.425 62.3914 112.383L68.0896 67.2422C43.2389 71.5256 7.53982 81.6546 -1.70553 108.679C-10.3614 133.976 13.7654 155.952 32.8249 168.005C50.7468 179.345 71.0163 186.908 91.4616 192.257L85.7427 237.47L85.753 237.491Z",
    stroke: "url(#paint10_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2457 265.787C55.8142 263.252 32.7525 252.585 47.0446 240.822C56.7656 232.814 74.5738 234.645 85.7634 237.49L91.4822 192.277C80.303 189.431 62.4845 187.6 52.7531 195.598C38.4714 207.351 61.5331 218.029 70.9646 220.553L65.2561 265.787H65.2457Z",
    stroke: "url(#paint11_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-65.7714 129.559C-102.225 183.308 -27.063 230.818 14.2619 248.552C30.767 255.639 47.8823 261.247 65.2457 265.789L70.9543 220.555C22.2662 207.87 -55.4712 180.142 -68.0569 123.868C-71.1594 109.994 -68.0673 96.0781 -60.1043 84.3867L-65.7714 129.548V129.559Z",
    stroke: "url(#paint12_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 89.6219C127.006 72.9747 49.4128 68.5671 -15.5632 93.9777C-34.6537 101.437 -53.8786 112.342 -65.7714 129.559L-60.1042 84.397C-40.2174 55.6342 -1.85025 43.6532 30.9118 37.4247C63.6739 31.1962 100.438 30.2444 135.041 33.5138C156.665 35.552 178.145 39.225 199.21 44.5223L193.481 89.6322V89.6219Z",
    stroke: "url(#paint13_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.907 88.6506L190.72 89.0851L196.439 43.9752C187.69 42.475 161.484 40.654 158.682 54.2077C156.417 65.1437 173.294 70.9584 180.988 73.1621L175.27 118.293C167.7 116.12 151.494 110.637 152.828 100.083C154.514 86.7262 179.468 87.5642 187.907 88.6609V88.6506Z",
    stroke: "url(#paint14_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.72 89.0826L193.481 89.6206L199.21 44.5107L196.439 43.9727L190.72 89.0826Z",
    stroke: "url(#paint15_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.439 43.9735L199.2 44.5116C136.685 28.8576 66.5591 24.8432 4.28229 43.9322C-24.219 52.6645 -60.0112 69.5186 -67.9225 101.396C-75.5442 132.072 -51.1691 159.149 -28.5211 176.065C0.704105 197.906 35.8964 211.408 70.9439 220.554C61.5124 218.03 38.4404 207.352 52.7325 195.599C62.4639 187.591 80.272 189.432 91.4616 192.278C59.0822 183.794 -2.01572 162.242 -3.47388 120.412C-4.93204 78.582 57.0139 67.4183 86.994 64.8421C118.432 62.1313 150.471 65.2663 180.978 73.1605C173.284 70.9567 156.396 65.1525 158.671 54.2061C161.484 40.6524 187.679 42.463 196.428 43.9735H196.439Z",
    stroke: "url(#paint16_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 89.6228C184.236 87.6467 157.244 84.9049 153.17 98.5931C149.819 109.86 167.472 116.068 175.27 118.292C127.202 105.856 66.5591 101.79 20.9942 125.359C7.15722 132.519 -7.03139 144.179 -8.95492 160.681C-10.8785 177.184 0.455894 191.938 12.2349 202.242C32.7939 220.214 59.682 230.653 85.7634 237.492C74.5842 234.647 56.776 232.816 47.0446 240.824C32.7629 252.577 55.8039 263.265 65.2458 265.79C34.3245 257.709 3.71348 246.256 -23.2573 228.874C-47.5703 213.21 -76.144 188.047 -74.9547 156.232C-73.7138 122.917 -39.7314 102.825 -12.016 92.6336C16.2578 82.2355 46.7344 78.0142 76.7145 76.99C115.95 75.6449 155.424 80.0732 193.481 89.6228V89.6228Z",
    stroke: "url(#paint17_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4018 112.382C99.7245 106.019 138.712 108.844 175.27 118.28L180.988 73.1489C144.421 63.7131 105.433 60.8885 68.0897 67.2411L62.3915 112.382H62.4018Z",
    stroke: "url(#paint18_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.753 237.491C54.7801 229.348 17.9434 215.422 -0.991961 187.777C-15.3254 166.846 -8.38617 144.778 11.7282 130.851C26.5786 120.577 44.7901 115.425 62.3914 112.383L68.0896 67.2422C43.2389 71.5256 7.53982 81.6546 -1.70553 108.679C-10.3614 133.976 13.7654 155.952 32.8249 168.005C50.7468 179.345 71.0163 186.908 91.4616 192.257L85.7427 237.47L85.753 237.491Z",
    stroke: "url(#paint19_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2457 265.787C55.8142 263.252 32.7525 252.585 47.0446 240.822C56.7656 232.814 74.5738 234.645 85.7634 237.49L91.4822 192.277C80.303 189.431 62.4845 187.6 52.7531 195.598C38.4714 207.351 61.5331 218.029 70.9646 220.553L65.2561 265.787H65.2457Z",
    stroke: "url(#paint20_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-65.7714 129.559C-102.225 183.308 -27.063 230.818 14.2619 248.552C30.767 255.639 47.8823 261.247 65.2457 265.789L70.9543 220.555C22.2662 207.87 -55.4712 180.142 -68.0569 123.868C-71.1594 109.994 -68.0673 96.0781 -60.1043 84.3867L-65.7714 129.548V129.559Z",
    stroke: "url(#paint21_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 89.6219C127.006 72.9747 49.4128 68.5671 -15.5632 93.9777C-34.6537 101.437 -53.8786 112.342 -65.7714 129.559L-60.1042 84.397C-40.2174 55.6342 -1.85025 43.6532 30.9118 37.4247C63.6739 31.1962 100.438 30.2444 135.041 33.5138C156.665 35.552 178.145 39.225 199.21 44.5223L193.481 89.6322V89.6219Z",
    stroke: "url(#paint22_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.907 88.6506L190.72 89.0851L196.439 43.9752C187.69 42.475 161.484 40.654 158.682 54.2077C156.417 65.1437 173.294 70.9584 180.988 73.1621L175.27 118.293C167.7 116.12 151.494 110.637 152.828 100.083C154.514 86.7262 179.468 87.5642 187.907 88.6609V88.6506Z",
    stroke: "url(#paint23_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.72 89.0826L193.481 89.6206L199.21 44.5107L196.439 43.9727L190.72 89.0826Z",
    stroke: "url(#paint24_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.439 43.9735L199.2 44.5116C136.685 28.8576 66.5591 24.8432 4.28229 43.9322C-24.219 52.6645 -60.0112 69.5186 -67.9225 101.396C-75.5442 132.072 -51.1691 159.149 -28.5211 176.065C0.704105 197.906 35.8964 211.408 70.9439 220.554C61.5124 218.03 38.4404 207.352 52.7325 195.599C62.4639 187.591 80.272 189.432 91.4616 192.278C59.0822 183.794 -2.01572 162.242 -3.47388 120.412C-4.93204 78.582 57.0139 67.4183 86.994 64.8421C118.432 62.1313 150.471 65.2663 180.978 73.1605C173.284 70.9567 156.396 65.1525 158.671 54.2061C161.484 40.6524 187.679 42.463 196.428 43.9735H196.439Z",
    stroke: "url(#paint25_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 89.6228C184.236 87.6467 157.244 84.9049 153.17 98.5931C149.819 109.86 167.472 116.068 175.27 118.292C127.202 105.856 66.5591 101.79 20.9942 125.359C7.15722 132.519 -7.03139 144.179 -8.95492 160.681C-10.8785 177.184 0.455894 191.938 12.2349 202.242C32.7939 220.214 59.682 230.653 85.7634 237.492C74.5842 234.647 56.776 232.816 47.0446 240.824C32.7629 252.577 55.8039 263.265 65.2458 265.79C34.3245 257.709 3.71348 246.256 -23.2573 228.874C-47.5703 213.21 -76.144 188.047 -74.9547 156.232C-73.7138 122.917 -39.7314 102.825 -12.016 92.6336C16.2578 82.2355 46.7344 78.0142 76.7145 76.99C115.95 75.6449 155.424 80.0732 193.481 89.6228V89.6228Z",
    stroke: "url(#paint26_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4018 112.382C99.7245 106.019 138.712 108.844 175.27 118.28L180.988 73.1489C144.421 63.7131 105.433 60.8885 68.0897 67.2411L62.3915 112.382H62.4018Z",
    stroke: "url(#paint27_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.753 237.491C54.7801 229.348 17.9434 215.422 -0.991961 187.777C-15.3254 166.846 -8.38617 144.778 11.7282 130.851C26.5786 120.577 44.7901 115.425 62.3914 112.383L68.0896 67.2422C43.2389 71.5256 7.53982 81.6546 -1.70553 108.679C-10.3614 133.976 13.7654 155.952 32.8249 168.005C50.7468 179.345 71.0163 186.908 91.4616 192.257L85.7427 237.47L85.753 237.491Z",
    stroke: "url(#paint28_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2457 265.787C55.8142 263.252 32.7525 252.585 47.0446 240.822C56.7656 232.814 74.5738 234.645 85.7634 237.49L91.4822 192.277C80.303 189.431 62.4845 187.6 52.7531 195.598C38.4714 207.351 61.5331 218.029 70.9646 220.553L65.2561 265.787H65.2457Z",
    stroke: "url(#paint29_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-65.7714 129.559C-102.225 183.308 -27.063 230.818 14.2619 248.552C30.767 255.639 47.8823 261.247 65.2457 265.789L70.9543 220.555C22.2662 207.87 -55.4712 180.142 -68.0569 123.868C-71.1594 109.994 -68.0673 96.0781 -60.1043 84.3867L-65.7714 129.548V129.559Z",
    stroke: "url(#paint30_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 89.6219C127.006 72.9747 49.4128 68.5671 -15.5632 93.9777C-34.6537 101.437 -53.8786 112.342 -65.7714 129.559L-60.1042 84.397C-40.2174 55.6342 -1.85025 43.6532 30.9118 37.4247C63.6739 31.1962 100.438 30.2444 135.041 33.5138C156.665 35.552 178.145 39.225 199.21 44.5223L193.481 89.6322V89.6219Z",
    stroke: "url(#paint31_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.907 88.6506L190.72 89.0851L196.439 43.9752C187.69 42.475 161.484 40.654 158.682 54.2077C156.417 65.1437 173.294 70.9584 180.988 73.1621L175.27 118.293C167.7 116.12 151.494 110.637 152.828 100.083C154.514 86.7262 179.468 87.5642 187.907 88.6609V88.6506Z",
    stroke: "url(#paint32_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.439 43.9735L199.2 44.5116C136.685 28.8576 66.5591 24.8432 4.28229 43.9322C-24.219 52.6645 -60.0112 69.5186 -67.9225 101.396C-75.5442 132.072 -51.1691 159.149 -28.5211 176.065C0.704105 197.906 35.8964 211.408 70.9439 220.554C61.5124 218.03 38.4404 207.352 52.7325 195.599C62.4639 187.591 80.272 189.432 91.4616 192.278C59.0822 183.794 -2.01572 162.242 -3.47388 120.412C-4.93204 78.582 57.0139 67.4183 86.994 64.8421C118.432 62.1313 150.471 65.2663 180.978 73.1605C173.284 70.9567 156.396 65.1525 158.671 54.2061C161.484 40.6524 187.679 42.463 196.428 43.9735H196.439Z",
    stroke: "url(#paint33_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 89.6228C184.236 87.6467 157.244 84.9049 153.17 98.5931C149.819 109.86 167.472 116.068 175.27 118.292C127.202 105.856 66.5591 101.79 20.9942 125.359C7.15722 132.519 -7.03139 144.179 -8.95492 160.681C-10.8785 177.184 0.455894 191.938 12.2349 202.242C32.7939 220.214 59.682 230.653 85.7634 237.492C74.5842 234.647 56.776 232.816 47.0446 240.824C32.7629 252.577 55.8039 263.265 65.2458 265.79C34.3245 257.709 3.71348 246.256 -23.2573 228.874C-47.5703 213.21 -76.144 188.047 -74.9547 156.232C-73.7138 122.917 -39.7314 102.825 -12.016 92.6336C16.2578 82.2355 46.7344 78.0142 76.7145 76.99C115.95 75.6449 155.424 80.0732 193.481 89.6228V89.6228Z",
    stroke: "url(#paint34_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2664 265.759C131.566 283.409 209.707 287.507 274.921 263.017C294.115 255.805 313.464 245.263 325.967 228.522L331.737 183.34C311.137 210.871 273.793 222.418 241.393 228.512C206.697 235.03 170.843 235.568 135.785 232.071C113.965 229.898 92.1751 226.194 70.9749 220.525L65.2664 265.759V265.759Z",
    stroke: "url(#paint35_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3942 237.655C95.867 240.179 117.905 250.898 103.944 262.414C94.2331 270.422 76.4352 268.601 65.2664 265.766L70.9749 220.532C82.1541 223.367 99.9519 225.198 109.663 217.19C123.624 205.685 101.576 194.966 92.1027 192.441L86.3838 237.655H86.3942Z",
    stroke: "url(#paint36_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.386 243.511C162.022 249.915 122.993 247.091 86.3942 237.655L92.113 192.441C128.722 201.888 167.762 204.691 205.126 198.308L199.386 243.511V243.511Z",
    stroke: "url(#paint37_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.311 118.228C206.511 127.105 243.141 139.935 262.49 167.984C276.886 188.852 270.153 210.962 250.049 224.961C235.219 235.287 216.987 240.46 199.386 243.512L205.126 198.309C229.956 194.005 265.696 183.824 274.807 156.727C283.339 131.358 259.026 109.413 239.925 97.3805C221.775 85.9581 201.558 78.8812 181.03 73.0977L175.311 118.228V118.228Z",
    stroke: "url(#paint38_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.486 90.916C210.131 94.4545 228.787 108.018 210.296 117.082C199.975 122.141 186.076 120.993 175.311 118.241L181.03 73.11C191.785 75.8518 205.715 77.0313 216.025 71.9616C234.506 62.8671 215.86 49.3652 204.215 45.8164L198.486 90.9264V90.916Z",
    stroke: "url(#paint39_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.001 154.018L314.849 151.67L320.61 106.539C340.827 128.049 350.642 157.691 331.737 183.36L325.967 228.543C344.054 203.97 335.967 175.383 317.001 154.029V154.018Z",
    stroke: "url(#paint40_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.85 151.658C284.621 119.677 240.173 102.016 198.486 90.9146L204.216 45.8047C245.923 56.9477 290.33 74.5468 320.61 106.527L314.85 151.658V151.658Z",
    stroke: "url(#paint41_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.61 106.527C290.361 74.5571 245.902 56.9063 204.215 45.8047C215.85 49.3431 234.527 62.8968 216.025 71.9498C205.705 77.0092 191.795 75.8504 181.03 73.0983C213.481 82.2548 274.807 102.647 276.503 144.995C278.168 186.463 216.17 198.134 186.2 200.73C154.731 203.462 122.652 200.337 92.1027 192.443C101.565 194.968 123.634 205.676 109.663 217.191C99.9519 225.2 82.1541 223.368 70.9749 220.533C119.921 233.58 172.436 237.729 222.737 231.407C263.245 226.317 323.464 212.836 339.4 169.391C347.849 146.361 336.35 123.278 320.599 106.527H320.61Z",
    stroke: "url(#paint42_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.626 149.362C327.332 164.219 339.649 184.477 335.884 206.184C332.12 227.89 312.512 244.786 293.256 254.873C251.063 276.973 199.531 281.081 152.746 278.949C123.293 277.615 93.7677 273.362 65.2664 265.758C76.4352 268.593 94.2434 270.413 103.944 262.405C117.905 250.9 95.867 240.171 86.3941 237.647C134.482 250.073 195.249 254.159 240.804 230.466C254.62 223.276 268.757 211.584 270.588 195.061C272.418 178.538 261.011 163.795 249.191 153.51C228.301 135.332 201.547 125.627 175.311 118.219C186.066 120.971 199.996 122.14 210.296 117.06C228.777 107.966 210.141 94.4537 198.486 90.8945C239.325 101.81 282.263 118.871 312.626 149.341V149.362Z",
    stroke: "url(#paint43_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2664 265.759C131.566 283.409 209.707 287.507 274.921 263.017C294.115 255.805 313.464 245.263 325.967 228.522L331.737 183.34C311.137 210.871 273.793 222.418 241.393 228.512C206.697 235.03 170.843 235.568 135.785 232.071C113.965 229.898 92.1751 226.194 70.9749 220.525L65.2664 265.759V265.759Z",
    stroke: "url(#paint44_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3942 237.655C95.867 240.179 117.905 250.898 103.944 262.414C94.2331 270.422 76.4352 268.601 65.2664 265.766L70.9749 220.532C82.1541 223.367 99.9519 225.198 109.663 217.19C123.624 205.685 101.576 194.966 92.1027 192.441L86.3838 237.655H86.3942Z",
    stroke: "url(#paint45_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.386 243.511C162.022 249.915 122.993 247.091 86.3942 237.655L92.113 192.441C128.722 201.888 167.762 204.691 205.126 198.308L199.386 243.511V243.511Z",
    stroke: "url(#paint46_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.311 118.228C206.511 127.105 243.141 139.935 262.49 167.984C276.886 188.852 270.153 210.962 250.049 224.961C235.219 235.287 216.987 240.46 199.386 243.512L205.126 198.309C229.956 194.005 265.696 183.824 274.807 156.727C283.339 131.358 259.026 109.413 239.925 97.3805C221.775 85.9581 201.558 78.8812 181.03 73.0977L175.311 118.228V118.228Z",
    stroke: "url(#paint47_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.486 90.916C210.131 94.4545 228.787 108.018 210.296 117.082C199.975 122.141 186.076 120.993 175.311 118.241L181.03 73.11C191.785 75.8518 205.715 77.0313 216.025 71.9616C234.506 62.8671 215.86 49.3652 204.215 45.8164L198.486 90.9264V90.916Z",
    stroke: "url(#paint48_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.001 154.018L314.849 151.67L320.61 106.539C340.827 128.049 350.642 157.691 331.737 183.36L325.967 228.543C344.054 203.97 335.967 175.383 317.001 154.029V154.018Z",
    stroke: "url(#paint49_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.85 151.658C284.621 119.677 240.173 102.016 198.486 90.9146L204.216 45.8047C245.923 56.9477 290.33 74.5468 320.61 106.527L314.85 151.658V151.658Z",
    stroke: "url(#paint50_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.61 106.527C290.361 74.5571 245.902 56.9063 204.215 45.8047C215.85 49.3431 234.527 62.8968 216.025 71.9498C205.705 77.0092 191.795 75.8504 181.03 73.0983C213.481 82.2548 274.807 102.647 276.503 144.995C278.168 186.463 216.17 198.134 186.2 200.73C154.731 203.462 122.652 200.337 92.1027 192.443C101.565 194.968 123.634 205.676 109.663 217.191C99.9519 225.2 82.1541 223.368 70.9749 220.533C119.921 233.58 172.436 237.729 222.737 231.407C263.245 226.317 323.464 212.836 339.4 169.391C347.849 146.361 336.35 123.278 320.599 106.527H320.61Z",
    stroke: "url(#paint51_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.626 149.362C327.332 164.219 339.649 184.477 335.884 206.184C332.12 227.89 312.512 244.786 293.256 254.873C251.063 276.973 199.531 281.081 152.746 278.949C123.293 277.615 93.7677 273.362 65.2664 265.758C76.4352 268.593 94.2434 270.413 103.944 262.405C117.905 250.9 95.867 240.171 86.3941 237.647C134.482 250.073 195.249 254.159 240.804 230.466C254.62 223.276 268.757 211.584 270.588 195.061C272.418 178.538 261.011 163.795 249.191 153.51C228.301 135.332 201.547 125.627 175.311 118.219C186.066 120.971 199.996 122.14 210.296 117.06C228.777 107.966 210.141 94.4537 198.486 90.8945C239.325 101.81 282.263 118.871 312.626 149.341V149.362Z",
    stroke: "url(#paint52_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2664 265.759C131.566 283.409 209.707 287.507 274.921 263.017C294.115 255.805 313.464 245.263 325.967 228.522L331.737 183.34C311.137 210.871 273.793 222.418 241.393 228.512C206.697 235.03 170.843 235.568 135.785 232.071C113.965 229.898 92.1751 226.194 70.9749 220.525L65.2664 265.759V265.759Z",
    stroke: "url(#paint53_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3942 237.655C95.867 240.179 117.905 250.898 103.944 262.414C94.2331 270.422 76.4352 268.601 65.2664 265.766L70.9749 220.532C82.1541 223.367 99.9519 225.198 109.663 217.19C123.624 205.685 101.576 194.966 92.1027 192.441L86.3838 237.655H86.3942Z",
    stroke: "url(#paint54_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.386 243.511C162.022 249.915 122.993 247.091 86.3942 237.655L92.113 192.441C128.722 201.888 167.762 204.691 205.126 198.308L199.386 243.511V243.511Z",
    stroke: "url(#paint55_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.311 118.228C206.511 127.105 243.141 139.935 262.49 167.984C276.886 188.852 270.153 210.962 250.049 224.961C235.219 235.287 216.987 240.46 199.386 243.512L205.126 198.309C229.956 194.005 265.696 183.824 274.807 156.727C283.339 131.358 259.026 109.413 239.925 97.3805C221.775 85.9581 201.558 78.8812 181.03 73.0977L175.311 118.228V118.228Z",
    stroke: "url(#paint56_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.486 90.916C210.131 94.4545 228.787 108.018 210.296 117.082C199.975 122.141 186.076 120.993 175.311 118.241L181.03 73.11C191.785 75.8518 205.715 77.0313 216.025 71.9616C234.506 62.8671 215.86 49.3652 204.215 45.8164L198.486 90.9264V90.916Z",
    stroke: "url(#paint57_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.001 154.018L314.849 151.67L320.61 106.539C340.827 128.049 350.642 157.691 331.737 183.36L325.967 228.543C344.054 203.97 335.967 175.383 317.001 154.029V154.018Z",
    stroke: "url(#paint58_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.85 151.658C284.621 119.677 240.173 102.016 198.486 90.9146L204.216 45.8047C245.923 56.9477 290.33 74.5468 320.61 106.527L314.85 151.658V151.658Z",
    stroke: "url(#paint59_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.61 106.527C290.361 74.5571 245.902 56.9063 204.215 45.8047C215.85 49.3431 234.527 62.8968 216.025 71.9498C205.705 77.0092 191.795 75.8504 181.03 73.0983C213.481 82.2548 274.807 102.647 276.503 144.995C278.168 186.463 216.17 198.134 186.2 200.73C154.731 203.462 122.652 200.337 92.1027 192.443C101.565 194.968 123.634 205.676 109.663 217.191C99.9519 225.2 82.1541 223.368 70.9749 220.533C119.921 233.58 172.436 237.729 222.737 231.407C263.245 226.317 323.464 212.836 339.4 169.391C347.849 146.361 336.35 123.278 320.599 106.527H320.61Z",
    stroke: "url(#paint60_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.626 149.362C327.332 164.219 339.649 184.477 335.884 206.184C332.12 227.89 312.512 244.786 293.256 254.873C251.063 276.973 199.531 281.081 152.746 278.949C123.293 277.615 93.7677 273.362 65.2664 265.758C76.4352 268.593 94.2434 270.413 103.944 262.405C117.905 250.9 95.867 240.171 86.3941 237.647C134.482 250.073 195.249 254.159 240.804 230.466C254.62 223.276 268.757 211.584 270.588 195.061C272.418 178.538 261.011 163.795 249.191 153.51C228.301 135.332 201.547 125.627 175.311 118.219C186.066 120.971 199.996 122.14 210.296 117.06C228.777 107.966 210.141 94.4537 198.486 90.8945C239.325 101.81 282.263 118.871 312.626 149.341V149.362Z",
    stroke: "url(#paint61_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2664 265.759C131.566 283.409 209.707 287.507 274.921 263.017C294.115 255.805 313.464 245.263 325.967 228.522L331.737 183.34C311.137 210.871 273.793 222.418 241.393 228.512C206.697 235.03 170.843 235.568 135.785 232.071C113.965 229.898 92.1751 226.194 70.9749 220.525L65.2664 265.759V265.759Z",
    stroke: "url(#paint62_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3942 237.655C95.867 240.179 117.905 250.898 103.944 262.414C94.2331 270.422 76.4352 268.601 65.2664 265.766L70.9749 220.532C82.1541 223.367 99.9519 225.198 109.663 217.19C123.624 205.685 101.576 194.966 92.1027 192.441L86.3838 237.655H86.3942Z",
    stroke: "url(#paint63_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.386 243.511C162.022 249.915 122.993 247.091 86.3942 237.655L92.113 192.441C128.722 201.888 167.762 204.691 205.126 198.308L199.386 243.511V243.511Z",
    stroke: "url(#paint64_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.311 118.228C206.511 127.105 243.141 139.935 262.49 167.984C276.886 188.852 270.153 210.962 250.049 224.961C235.219 235.287 216.987 240.46 199.386 243.512L205.126 198.309C229.956 194.005 265.696 183.824 274.807 156.727C283.339 131.358 259.026 109.413 239.925 97.3805C221.775 85.9581 201.558 78.8812 181.03 73.0977L175.311 118.228V118.228Z",
    stroke: "url(#paint65_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.486 90.916C210.131 94.4545 228.787 108.018 210.296 117.082C199.975 122.141 186.076 120.993 175.311 118.241L181.03 73.11C191.785 75.8518 205.715 77.0313 216.025 71.9616C234.506 62.8671 215.86 49.3652 204.215 45.8164L198.486 90.9264V90.916Z",
    stroke: "url(#paint66_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.001 154.018L314.849 151.67L320.61 106.539C340.827 128.049 350.642 157.691 331.737 183.36L325.967 228.543C344.054 203.97 335.967 175.383 317.001 154.029V154.018Z",
    stroke: "url(#paint67_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.85 151.658C284.621 119.677 240.173 102.016 198.486 90.9146L204.216 45.8047C245.923 56.9477 290.33 74.5468 320.61 106.527L314.85 151.658V151.658Z",
    stroke: "url(#paint68_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.61 106.527C290.361 74.5571 245.902 56.9063 204.215 45.8047C215.85 49.3431 234.527 62.8968 216.025 71.9498C205.705 77.0092 191.795 75.8504 181.03 73.0983C213.481 82.2548 274.807 102.647 276.503 144.995C278.168 186.463 216.17 198.134 186.2 200.73C154.731 203.462 122.652 200.337 92.1027 192.443C101.565 194.968 123.634 205.676 109.663 217.191C99.9519 225.2 82.1541 223.368 70.9749 220.533C119.921 233.58 172.436 237.729 222.737 231.407C263.245 226.317 323.464 212.836 339.4 169.391C347.849 146.361 336.35 123.278 320.599 106.527H320.61Z",
    stroke: "url(#paint69_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.626 149.362C327.332 164.219 339.649 184.477 335.884 206.184C332.12 227.89 312.512 244.786 293.256 254.873C251.063 276.973 199.531 281.081 152.746 278.949C123.293 277.615 93.7677 273.362 65.2664 265.758C76.4352 268.593 94.2434 270.413 103.944 262.405C117.905 250.9 95.867 240.171 86.3941 237.647C134.482 250.073 195.249 254.159 240.804 230.466C254.62 223.276 268.757 211.584 270.588 195.061C272.418 178.538 261.011 163.795 249.191 153.51C228.301 135.332 201.547 125.627 175.311 118.219C186.066 120.971 199.996 122.14 210.296 117.06C228.777 107.966 210.141 94.4537 198.486 90.8945C239.325 101.81 282.263 118.871 312.626 149.341V149.362Z",
    stroke: "url(#paint70_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-106.176 215.381C-70.301 251.5 -20.796 272.948 27.3026 287.35C74.6462 301.535 124.162 309.067 173.563 310.03C201.33 310.568 229.118 308.871 256.565 304.618L262.325 259.384C166.397 274.221 61.1815 260.688 -26.9596 219.479C-53.7132 206.97 -79.5877 191.223 -100.519 170.168L-106.186 215.392L-106.176 215.381Z",
    stroke: "url(#paint71_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7488 50.7506C-43.8267 58.8414 -152.516 88.7112 -135.618 166.174C-131.471 185.201 -119.599 201.703 -106.186 215.381L-100.519 170.157C-124.656 145.554 -141.513 110.645 -124.015 77.351C-108.037 46.9638 -73.569 29.7579 -42.3789 19.3185C-22.9367 12.821 -2.83276 8.58933 17.4263 5.64062L11.7488 50.7506V50.7506Z",
    stroke: "url(#paint72_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.216 150.331L373.383 147.03L379.153 101.91C400.819 126.483 413.208 159.601 396.175 190.257C380.363 218.72 348.211 235.285 318.614 245.621C300.34 252.004 281.415 256.298 262.325 259.391L256.564 304.626C309.296 296.059 404.128 269.148 398.523 199.145C397.055 180.842 387.737 164.226 376.216 150.331Z",
    stroke: "url(#paint73_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.383 147.034C339.576 109.208 290.164 86.808 242.665 71.6506C195.249 56.514 145.517 48.299 95.805 46.5711C67.7277 45.5986 39.5987 46.9126 11.7592 50.751L17.4367 5.6411C113.696 -7.62289 219.656 6.624 307.083 49.9958C333.63 63.1666 359.267 79.669 379.164 101.903L373.393 147.024L373.383 147.034Z",
    stroke: "url(#paint74_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.225 276.34C78.5243 271.156 35.6482 260.158 -2.81205 240.562C-33.8471 224.743 -75.9889 196.414 -74.9858 156.84C-74.4377 135.195 -58.884 118.155 -41.5929 106.991L-35.9257 61.8398C-70.1976 83.8982 -79.2362 120.514 -53.041 153.022C-27.5697 184.63 13.5069 202.943 51.295 214.903C75.9079 222.694 101.317 227.991 126.933 231.106L121.204 276.34H121.225Z",
    stroke: "url(#paint75_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.299 147.075L312.626 149.362L318.386 104.231C284.549 70.2333 235.085 52.4997 189.262 42.1327C140.874 31.1966 89.7449 28.0513 40.6225 35.7386C14.0757 39.8875 -13.0708 47.2437 -35.8947 61.8424L-41.5618 106.994C-1.98469 81.6556 49.8162 76.1721 95.743 76.8032C145.786 77.486 196.677 86.6943 243.048 105.804C267.351 115.819 291.198 128.804 310.31 147.086L310.299 147.075Z",
    stroke: "url(#paint76_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.626 149.36C341.21 178.247 345.037 216.652 311.385 243.294C279.575 268.487 234.64 276.216 195.187 278.658C170.533 280.189 145.744 279.268 121.225 276.34L126.954 231.106C168.63 236.072 211.806 235.669 252.831 226.109C287.258 218.09 337.063 199.56 342.006 158.599C344.53 137.689 332.513 118.507 318.386 104.219L312.626 149.349V149.36Z",
    stroke: "url(#paint77_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.153 101.912C323.95 40.165 229.542 15.0338 150.243 5.31861C72.1953 -4.25173 -26.1219 -3.25849 -93.0628 43.9311C-131.12 70.7591 -142.93 113.562 -115.183 152.805C-90.5601 187.641 -50.1763 210.186 -11.6334 226.244C64.5219 257.986 150.998 270.34 233.058 262.973C296.938 257.241 445.267 219.684 395.421 124.932C391.036 116.593 385.379 108.958 379.153 101.901V101.912Z",
    stroke: "url(#paint78_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.373 143.744C401.357 176.8 409.682 221.259 375.006 255.153C345.419 284.071 301.83 296.818 262.139 303.698C180.471 317.852 93.1473 309.285 14.6238 283.368C-44.7884 263.751 -183.417 196.272 -123.984 113.378C-99.578 79.3381 -54.0958 63.8911 -14.9634 55.4898C25.379 46.8196 67.1486 44.7814 108.277 47.1404C190.596 51.8686 281.912 72.6958 348.366 124.003C356.174 130.035 363.569 136.584 370.363 143.744H370.373Z",
    stroke: "url(#paint79_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.386 104.23C338.521 124.622 350.931 153.53 334.095 179.913C316.473 207.527 280.753 219.932 250.318 226.689C184.008 241.401 111.369 234.728 47.1997 213.59C2.80342 198.96 -93.4972 154.626 -64.7476 92.5175C-51.0244 62.865 -15.1288 48.6802 14.448 41.0963C44.0249 33.5125 77.0558 30.8742 108.577 31.8571C173.232 33.8746 244.155 49.0423 297.776 87.0133C305.087 92.1864 312.037 97.8873 318.366 104.23H318.386Z",
    stroke: "url(#paint80_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.85 151.657C269.564 103.805 194.381 85.0163 131.163 78.7879C72.2366 72.9836 -9.91667 74.401 -55.8539 118.062C-112.474 171.884 -31.2513 229.192 15.3581 249.006C78.4002 275.802 151.453 285.311 219.314 276.32C268.271 269.833 366.113 237.49 328.687 170.187C324.933 163.431 320.134 157.275 314.85 151.647V151.657Z",
    stroke: "url(#paint81_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-106.176 215.381C-70.301 251.5 -20.796 272.948 27.3026 287.35C74.6462 301.535 124.162 309.067 173.563 310.03C201.33 310.568 229.118 308.871 256.565 304.618L262.325 259.384C166.397 274.221 61.1815 260.688 -26.9596 219.479C-53.7132 206.97 -79.5877 191.223 -100.519 170.168L-106.186 215.392L-106.176 215.381Z",
    stroke: "url(#paint82_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7488 50.7506C-43.8267 58.8414 -152.516 88.7112 -135.618 166.174C-131.471 185.201 -119.599 201.703 -106.186 215.381L-100.519 170.157C-124.656 145.554 -141.513 110.645 -124.015 77.351C-108.037 46.9638 -73.569 29.7579 -42.3789 19.3185C-22.9367 12.821 -2.83276 8.58933 17.4263 5.64062L11.7488 50.7506V50.7506Z",
    stroke: "url(#paint83_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.216 150.331L373.383 147.03L379.153 101.91C400.819 126.483 413.208 159.601 396.175 190.257C380.363 218.72 348.211 235.285 318.614 245.621C300.34 252.004 281.415 256.298 262.325 259.391L256.564 304.626C309.296 296.059 404.128 269.148 398.523 199.145C397.055 180.842 387.737 164.226 376.216 150.331Z",
    stroke: "url(#paint84_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.383 147.034C339.576 109.208 290.164 86.808 242.665 71.6506C195.249 56.514 145.517 48.299 95.805 46.5711C67.7277 45.5986 39.5987 46.9126 11.7592 50.751L17.4367 5.6411C113.696 -7.62289 219.656 6.624 307.083 49.9958C333.63 63.1666 359.267 79.669 379.164 101.903L373.393 147.024L373.383 147.034Z",
    stroke: "url(#paint85_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.225 276.34C78.5243 271.156 35.6482 260.158 -2.81205 240.562C-33.8471 224.743 -75.9889 196.414 -74.9858 156.84C-74.4377 135.195 -58.884 118.155 -41.5929 106.991L-35.9257 61.8398C-70.1976 83.8982 -79.2362 120.514 -53.041 153.022C-27.5697 184.63 13.5069 202.943 51.295 214.903C75.9079 222.694 101.317 227.991 126.933 231.106L121.204 276.34H121.225Z",
    stroke: "url(#paint86_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.299 147.075L312.626 149.362L318.386 104.231C284.549 70.2333 235.085 52.4997 189.262 42.1327C140.874 31.1966 89.7449 28.0513 40.6225 35.7386C14.0757 39.8875 -13.0708 47.2437 -35.8947 61.8424L-41.5618 106.994C-1.98469 81.6556 49.8162 76.1721 95.743 76.8032C145.786 77.486 196.677 86.6943 243.048 105.804C267.351 115.819 291.198 128.804 310.31 147.086L310.299 147.075Z",
    stroke: "url(#paint87_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.626 149.36C341.21 178.247 345.037 216.652 311.385 243.294C279.575 268.487 234.64 276.216 195.187 278.658C170.533 280.189 145.744 279.268 121.225 276.34L126.954 231.106C168.63 236.072 211.806 235.669 252.831 226.109C287.258 218.09 337.063 199.56 342.006 158.599C344.53 137.689 332.513 118.507 318.386 104.219L312.626 149.349V149.36Z",
    stroke: "url(#paint88_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.153 101.912C323.95 40.165 229.542 15.0338 150.243 5.31861C72.1953 -4.25173 -26.1219 -3.25849 -93.0628 43.9311C-131.12 70.7591 -142.93 113.562 -115.183 152.805C-90.5601 187.641 -50.1763 210.186 -11.6334 226.244C64.5219 257.986 150.998 270.34 233.058 262.973C296.938 257.241 445.267 219.684 395.421 124.932C391.036 116.593 385.379 108.958 379.153 101.901V101.912Z",
    stroke: "url(#paint89_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.373 143.744C401.357 176.8 409.682 221.259 375.006 255.153C345.419 284.071 301.83 296.818 262.139 303.698C180.471 317.852 93.1473 309.285 14.6238 283.368C-44.7884 263.751 -183.417 196.272 -123.984 113.378C-99.578 79.3381 -54.0958 63.8911 -14.9634 55.4898C25.379 46.8196 67.1486 44.7814 108.277 47.1404C190.596 51.8686 281.912 72.6958 348.366 124.003C356.174 130.035 363.569 136.584 370.363 143.744H370.373Z",
    stroke: "url(#paint90_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.386 104.23C338.521 124.622 350.931 153.53 334.095 179.913C316.473 207.527 280.753 219.932 250.318 226.689C184.008 241.401 111.369 234.728 47.1997 213.59C2.80342 198.96 -93.4972 154.626 -64.7476 92.5175C-51.0244 62.865 -15.1288 48.6802 14.448 41.0963C44.0249 33.5125 77.0558 30.8742 108.577 31.8571C173.232 33.8746 244.155 49.0423 297.776 87.0133C305.087 92.1864 312.037 97.8873 318.366 104.23H318.386Z",
    stroke: "url(#paint91_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.85 151.657C269.564 103.805 194.381 85.0163 131.163 78.7879C72.2366 72.9836 -9.91667 74.401 -55.8539 118.062C-112.474 171.884 -31.2513 229.192 15.3581 249.006C78.4002 275.802 151.453 285.311 219.314 276.32C268.271 269.833 366.113 237.49 328.687 170.187C324.933 163.431 320.134 157.275 314.85 151.647V151.657Z",
    stroke: "url(#paint92_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-106.176 215.381C-70.301 251.5 -20.796 272.948 27.3026 287.35C74.6462 301.535 124.162 309.067 173.563 310.03C201.33 310.568 229.118 308.871 256.565 304.618L262.325 259.384C166.397 274.221 61.1815 260.688 -26.9596 219.479C-53.7132 206.97 -79.5877 191.223 -100.519 170.168L-106.186 215.392L-106.176 215.381Z",
    stroke: "url(#paint93_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7488 50.7506C-43.8267 58.8414 -152.516 88.7112 -135.618 166.174C-131.471 185.201 -119.599 201.703 -106.186 215.381L-100.519 170.157C-124.656 145.554 -141.513 110.645 -124.015 77.351C-108.037 46.9638 -73.569 29.7579 -42.3789 19.3185C-22.9367 12.821 -2.83276 8.58933 17.4263 5.64062L11.7488 50.7506V50.7506Z",
    stroke: "url(#paint94_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.216 150.331L373.383 147.03L379.153 101.91C400.819 126.483 413.208 159.601 396.175 190.257C380.363 218.72 348.211 235.285 318.614 245.621C300.34 252.004 281.415 256.298 262.325 259.391L256.564 304.626C309.296 296.059 404.128 269.148 398.523 199.145C397.055 180.842 387.737 164.226 376.216 150.331Z",
    stroke: "url(#paint95_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.383 147.034C339.576 109.208 290.164 86.808 242.665 71.6506C195.249 56.514 145.517 48.299 95.805 46.5711C67.7277 45.5986 39.5987 46.9126 11.7592 50.751L17.4367 5.6411C113.696 -7.62289 219.656 6.624 307.083 49.9958C333.63 63.1666 359.267 79.669 379.164 101.903L373.393 147.024L373.383 147.034Z",
    stroke: "url(#paint96_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.225 276.34C78.5243 271.156 35.6482 260.158 -2.81205 240.562C-33.8471 224.743 -75.9889 196.414 -74.9858 156.84C-74.4377 135.195 -58.884 118.155 -41.5929 106.991L-35.9257 61.8398C-70.1976 83.8982 -79.2362 120.514 -53.041 153.022C-27.5697 184.63 13.5069 202.943 51.295 214.903C75.9079 222.694 101.317 227.991 126.933 231.106L121.204 276.34H121.225Z",
    stroke: "url(#paint97_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.299 147.075L312.626 149.362L318.386 104.231C284.549 70.2333 235.085 52.4997 189.262 42.1327C140.874 31.1966 89.7449 28.0513 40.6225 35.7386C14.0757 39.8875 -13.0708 47.2437 -35.8947 61.8424L-41.5618 106.994C-1.98469 81.6556 49.8162 76.1721 95.743 76.8032C145.786 77.486 196.677 86.6943 243.048 105.804C267.351 115.819 291.198 128.804 310.31 147.086L310.299 147.075Z",
    stroke: "url(#paint98_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.626 149.36C341.21 178.247 345.037 216.652 311.385 243.294C279.575 268.487 234.64 276.216 195.187 278.658C170.533 280.189 145.744 279.268 121.225 276.34L126.954 231.106C168.63 236.072 211.806 235.669 252.831 226.109C287.258 218.09 337.063 199.56 342.006 158.599C344.53 137.689 332.513 118.507 318.386 104.219L312.626 149.349V149.36Z",
    stroke: "url(#paint99_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.153 101.912C323.95 40.165 229.542 15.0338 150.243 5.31861C72.1953 -4.25173 -26.1219 -3.25849 -93.0628 43.9311C-131.12 70.7591 -142.93 113.562 -115.183 152.805C-90.5601 187.641 -50.1763 210.186 -11.6334 226.244C64.5219 257.986 150.998 270.34 233.058 262.973C296.938 257.241 445.267 219.684 395.421 124.932C391.036 116.593 385.379 108.958 379.153 101.901V101.912Z",
    stroke: "url(#paint100_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.373 143.744C401.357 176.8 409.682 221.259 375.006 255.153C345.419 284.071 301.83 296.818 262.139 303.698C180.471 317.852 93.1473 309.285 14.6238 283.368C-44.7884 263.751 -183.417 196.272 -123.984 113.378C-99.578 79.3381 -54.0958 63.8911 -14.9634 55.4898C25.379 46.8196 67.1486 44.7814 108.277 47.1404C190.596 51.8686 281.912 72.6958 348.366 124.003C356.174 130.035 363.569 136.584 370.363 143.744H370.373Z",
    stroke: "url(#paint101_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.386 104.23C338.521 124.622 350.931 153.53 334.095 179.913C316.473 207.527 280.753 219.932 250.318 226.689C184.008 241.401 111.369 234.728 47.1997 213.59C2.80342 198.96 -93.4972 154.626 -64.7476 92.5175C-51.0244 62.865 -15.1288 48.6802 14.448 41.0963C44.0249 33.5125 77.0558 30.8742 108.577 31.8571C173.232 33.8746 244.155 49.0423 297.776 87.0133C305.087 92.1864 312.037 97.8873 318.366 104.23H318.386Z",
    stroke: "url(#paint102_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.85 151.657C269.564 103.805 194.381 85.0163 131.163 78.7879C72.2366 72.9836 -9.91667 74.401 -55.8539 118.062C-112.474 171.884 -31.2513 229.192 15.3581 249.006C78.4002 275.802 151.453 285.311 219.314 276.32C268.271 269.833 366.113 237.49 328.687 170.187C324.933 163.431 320.134 157.275 314.85 151.647V151.657Z",
    stroke: "url(#paint103_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48187 195.734C40.064 232.412 99.8899 244.921 148.164 246.68C164.256 247.269 180.409 246.493 196.325 244.01L202.064 198.807C148.94 207.074 88.6487 198.88 41.1706 172.9C30.1982 166.899 19.7842 159.657 11.1697 150.531L5.48187 195.724V195.734Z",
    stroke: "url(#paint104_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5757 111.422C44.1282 114.909 13.8275 122.41 -1.76759 143.465C-14.6842 160.909 -8.32413 180.991 5.48185 195.734L11.1697 150.542C-2.63627 135.798 -9.01702 115.737 3.90993 98.3031C19.505 77.2587 49.8161 69.768 74.2739 66.2812L68.5757 111.422V111.422Z",
    stroke: "url(#paint105_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.953 163.38L257.516 161.714L263.266 116.562C276.213 131.12 281.519 150.447 269.254 167.135C254.351 187.424 225.561 195.101 202.065 198.816L196.325 244.019C233.968 238.059 296.99 208.769 258.964 163.38H258.953Z",
    stroke: "url(#paint106_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.516 161.704C224.051 124.261 163.946 111.566 116.116 109.352C100.252 108.617 84.3155 109.207 68.5757 111.421L74.2739 66.2799C127.347 58.8513 187.741 67.3146 234.62 94.2046C245.147 100.247 255.148 107.479 263.266 116.563L257.516 161.714V161.704Z",
    stroke: "url(#paint107_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.266 116.564C229.966 79.3485 170.233 66.6018 122.662 64.2635C85.5979 62.4426 21.4078 64.9567 0.724714 103.228C-19.1518 140.019 31.9872 170.179 59.1338 181.487C107.894 201.797 166.727 208.357 218.249 195.558C248.436 188.057 291.995 164.105 270.908 127.035C268.767 123.279 266.13 119.792 263.266 116.554V116.564Z",
    stroke: "url(#paint108_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.996 160.037C284.27 190.186 265.086 221.235 231.279 234.799C183.108 254.136 123.882 249.398 75.2357 234.499C45.2038 225.301 -14.6738 200.905 -8.8412 159.861C-2.98788 118.662 60.9436 110.529 92.7232 109.257C143.697 107.208 203.74 117.761 244.889 149.99C248.829 153.073 252.552 156.405 255.996 160.037V160.037Z",
    stroke: "url(#paint109_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48187 195.734C40.064 232.412 99.8899 244.921 148.164 246.68C164.256 247.269 180.409 246.493 196.325 244.01L202.064 198.807C148.94 207.074 88.6487 198.88 41.1706 172.9C30.1982 166.899 19.7842 159.657 11.1697 150.531L5.48187 195.724V195.734Z",
    stroke: "url(#paint110_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5757 111.422C44.1282 114.909 13.8275 122.41 -1.76759 143.465C-14.6842 160.909 -8.32413 180.991 5.48185 195.734L11.1697 150.542C-2.63627 135.798 -9.01702 115.737 3.90993 98.3031C19.505 77.2587 49.8161 69.768 74.2739 66.2812L68.5757 111.422V111.422Z",
    stroke: "url(#paint111_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.953 163.38L257.516 161.714L263.266 116.562C276.213 131.12 281.519 150.447 269.254 167.135C254.351 187.424 225.561 195.101 202.065 198.816L196.325 244.019C233.968 238.059 296.99 208.769 258.964 163.38H258.953Z",
    stroke: "url(#paint112_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.516 161.704C224.051 124.261 163.946 111.566 116.116 109.352C100.252 108.617 84.3155 109.207 68.5757 111.421L74.2739 66.2799C127.347 58.8513 187.741 67.3146 234.62 94.2046C245.147 100.247 255.148 107.479 263.266 116.563L257.516 161.714V161.704Z",
    stroke: "url(#paint113_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.266 116.564C229.966 79.3485 170.233 66.6018 122.662 64.2635C85.5979 62.4426 21.4078 64.9567 0.724714 103.228C-19.1518 140.019 31.9872 170.179 59.1338 181.487C107.894 201.797 166.727 208.357 218.249 195.558C248.436 188.057 291.995 164.105 270.908 127.035C268.767 123.279 266.13 119.792 263.266 116.554V116.564Z",
    stroke: "url(#paint114_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.996 160.037C284.27 190.186 265.086 221.235 231.279 234.799C183.108 254.136 123.882 249.398 75.2357 234.499C45.2038 225.301 -14.6738 200.905 -8.8412 159.861C-2.98788 118.662 60.9436 110.529 92.7232 109.257C143.697 107.208 203.74 117.761 244.889 149.99C248.829 153.073 252.552 156.405 255.996 160.037V160.037Z",
    stroke: "url(#paint115_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48187 195.734C40.064 232.412 99.8899 244.921 148.164 246.68C164.256 247.269 180.409 246.493 196.325 244.01L202.064 198.807C148.94 207.074 88.6487 198.88 41.1706 172.9C30.1982 166.899 19.7842 159.657 11.1697 150.531L5.48187 195.724V195.734Z",
    stroke: "url(#paint116_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5757 111.422C44.1282 114.909 13.8275 122.41 -1.76759 143.465C-14.6842 160.909 -8.32413 180.991 5.48185 195.734L11.1697 150.542C-2.63627 135.798 -9.01702 115.737 3.90993 98.3031C19.505 77.2587 49.8161 69.768 74.2739 66.2812L68.5757 111.422V111.422Z",
    stroke: "url(#paint117_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.953 163.38L257.516 161.714L263.266 116.562C276.213 131.12 281.519 150.447 269.254 167.135C254.351 187.424 225.561 195.101 202.065 198.816L196.325 244.019C233.968 238.059 296.99 208.769 258.964 163.38H258.953Z",
    stroke: "url(#paint118_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.516 161.704C224.051 124.261 163.946 111.566 116.116 109.352C100.252 108.617 84.3155 109.207 68.5757 111.421L74.2739 66.2799C127.347 58.8513 187.741 67.3146 234.62 94.2046C245.147 100.247 255.148 107.479 263.266 116.563L257.516 161.714V161.704Z",
    stroke: "url(#paint119_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.266 116.564C229.966 79.3485 170.233 66.6018 122.662 64.2635C85.5979 62.4426 21.4078 64.9567 0.724714 103.228C-19.1518 140.019 31.9872 170.179 59.1338 181.487C107.894 201.797 166.727 208.357 218.249 195.558C248.436 188.057 291.995 164.105 270.908 127.035C268.767 123.279 266.13 119.792 263.266 116.554V116.564Z",
    stroke: "url(#paint120_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.996 160.037C284.27 190.186 265.086 221.235 231.279 234.799C183.108 254.136 123.882 249.398 75.2357 234.499C45.2038 225.301 -14.6738 200.905 -8.8412 159.861C-2.98788 118.662 60.9436 110.529 92.7232 109.257C143.697 107.208 203.74 117.761 244.889 149.99C248.829 153.073 252.552 156.405 255.996 160.037V160.037Z",
    stroke: "url(#paint121_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5338 239.829C39.185 244.971 42.5874 254.335 50.0954 259.301L55.8039 214.067C48.3063 209.101 44.8936 199.737 54.2424 194.605L48.5338 239.819V239.829Z",
    stroke: "url(#paint122_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2598 237.613C74.4808 234.499 59.5062 233.568 48.5441 239.828L54.2527 194.614C65.225 188.365 80.1996 189.286 91.9787 192.41L86.2598 237.624V237.613Z",
    stroke: "url(#paint123_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5115 265.56L65.2665 265.757L70.975 220.523C65.6387 219.167 60.3956 217.139 55.8039 214.066L50.0954 259.301C54.4699 262.229 59.4338 264.215 64.5012 265.56H64.5115Z",
    stroke: "url(#paint124_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2665 265.755L86.2598 237.613L91.9684 192.41L70.975 220.531L65.2665 265.755Z",
    stroke: "url(#paint125_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.975 220.53L91.9683 192.409C81.7612 189.708 31.8322 191.219 52.9083 211.808C57.624 216.412 64.7287 218.947 70.975 220.53Z",
    stroke: "url(#paint126_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2598 237.614L65.2665 265.756C57.6861 263.832 42.3082 258.504 42.5357 248.416C42.7632 238.328 57.3241 236.073 64.6666 235.514C72.0091 234.955 79.2689 235.762 86.2495 237.614H86.2598Z",
    stroke: "url(#paint127_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5338 239.829C39.185 244.971 42.5874 254.335 50.0954 259.301L55.8039 214.067C48.3063 209.101 44.8936 199.737 54.2424 194.605L48.5338 239.819V239.829Z",
    stroke: "url(#paint128_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2598 237.613C74.4808 234.499 59.5062 233.568 48.5441 239.828L54.2527 194.614C65.225 188.365 80.1996 189.286 91.9787 192.41L86.2598 237.624V237.613Z",
    stroke: "url(#paint129_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5115 265.56L65.2665 265.757L70.975 220.523C65.6387 219.167 60.3956 217.139 55.8039 214.066L50.0954 259.301C54.4699 262.229 59.4338 264.215 64.5012 265.56H64.5115Z",
    stroke: "url(#paint130_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2665 265.755L86.2598 237.613L91.9684 192.41L70.975 220.531L65.2665 265.755Z",
    stroke: "url(#paint131_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.975 220.53L91.9683 192.409C81.7612 189.708 31.8322 191.219 52.9083 211.808C57.624 216.412 64.7287 218.947 70.975 220.53Z",
    stroke: "url(#paint132_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2598 237.614L65.2665 265.756C57.6861 263.832 42.3082 258.504 42.5357 248.416C42.7632 238.328 57.3241 236.073 64.6666 235.514C72.0091 234.955 79.2689 235.762 86.2495 237.614H86.2598Z",
    stroke: "url(#paint133_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5338 239.829C39.185 244.971 42.5874 254.335 50.0954 259.301L55.8039 214.067C48.3063 209.101 44.8936 199.737 54.2424 194.605L48.5338 239.819V239.829Z",
    stroke: "url(#paint134_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2598 237.613C74.4808 234.499 59.5062 233.568 48.5441 239.828L54.2527 194.614C65.225 188.365 80.1996 189.286 91.9787 192.41L86.2598 237.624V237.613Z",
    stroke: "url(#paint135_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5115 265.56L65.2665 265.757L70.975 220.523C65.6387 219.167 60.3956 217.139 55.8039 214.066L50.0954 259.301C54.4699 262.229 59.4338 264.215 64.5012 265.56H64.5115Z",
    stroke: "url(#paint136_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2665 265.755L86.2598 237.613L91.9684 192.41L70.975 220.531L65.2665 265.755Z",
    stroke: "url(#paint137_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.975 220.53L91.9683 192.409C81.7612 189.708 31.8322 191.219 52.9083 211.808C57.624 216.412 64.7287 218.947 70.975 220.53Z",
    stroke: "url(#paint138_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2598 237.614L65.2665 265.756C57.6861 263.832 42.3082 258.504 42.5357 248.416C42.7632 238.328 57.3241 236.073 64.6666 235.514C72.0091 234.955 79.2689 235.762 86.2495 237.614H86.2598Z",
    stroke: "url(#paint139_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5338 239.829C39.185 244.971 42.5874 254.335 50.0954 259.301L55.8039 214.067C48.3063 209.101 44.8936 199.737 54.2424 194.605L48.5338 239.819V239.829Z",
    stroke: "url(#paint140_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2598 237.613C74.4808 234.499 59.5062 233.568 48.5441 239.828L54.2527 194.614C65.225 188.365 80.1996 189.286 91.9787 192.41L86.2598 237.624V237.613Z",
    stroke: "url(#paint141_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5115 265.56L65.2665 265.757L70.975 220.523C65.6387 219.167 60.3956 217.139 55.8039 214.066L50.0954 259.301C54.4699 262.229 59.4338 264.215 64.5012 265.56H64.5115Z",
    stroke: "url(#paint142_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2665 265.755L86.2598 237.613L91.9684 192.41L70.975 220.531L65.2665 265.755Z",
    stroke: "url(#paint143_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.975 220.53L91.9683 192.409C81.7612 189.708 31.8322 191.219 52.9083 211.808C57.624 216.412 64.7287 218.947 70.975 220.53Z",
    stroke: "url(#paint144_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2598 237.614L65.2665 265.756C57.6861 263.832 42.3082 258.504 42.5357 248.416C42.7632 238.328 57.3241 236.073 64.6666 235.514C72.0091 234.955 79.2689 235.762 86.2495 237.614H86.2598Z",
    stroke: "url(#paint145_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5338 239.829C39.185 244.971 42.5874 254.335 50.0954 259.301L55.8039 214.067C48.3063 209.101 44.8936 199.737 54.2424 194.605L48.5338 239.819V239.829Z",
    stroke: "url(#paint146_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2598 237.613C74.4808 234.499 59.5062 233.568 48.5441 239.828L54.2527 194.614C65.225 188.365 80.1996 189.286 91.9787 192.41L86.2598 237.624V237.613Z",
    stroke: "url(#paint147_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5115 265.56L65.2665 265.757L70.975 220.523C65.6387 219.167 60.3956 217.139 55.8039 214.066L50.0954 259.301C54.4699 262.229 59.4338 264.215 64.5012 265.56H64.5115Z",
    stroke: "url(#paint148_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2665 265.755L86.2598 237.613L91.9684 192.41L70.975 220.531L65.2665 265.755Z",
    stroke: "url(#paint149_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.975 220.53L91.9683 192.409C81.7612 189.708 31.8322 191.219 52.9083 211.808C57.624 216.412 64.7287 218.947 70.975 220.53Z",
    stroke: "url(#paint150_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2598 237.614L65.2665 265.756C57.6861 263.832 42.3082 258.504 42.5357 248.416C42.7632 238.328 57.3241 236.073 64.6666 235.514C72.0091 234.955 79.2689 235.762 86.2495 237.614H86.2598Z",
    stroke: "url(#paint151_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.278 92.7531C149.002 98.1642 153.47 107.507 160.822 112.173L166.541 67.0425C159.188 62.3867 154.721 53.0439 163.997 47.6328L158.278 92.7531Z",
    stroke: "url(#paint152_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.149 90.2918C184.432 87.0845 169.075 86.2361 158.278 92.7543L163.997 47.634C174.794 41.1158 190.151 41.9745 201.868 45.1715L196.139 90.2815L196.149 90.2918Z",
    stroke: "url(#paint153_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.556 118.03L175.301 118.226L181.02 73.0956C175.942 71.8023 170.957 69.8779 166.531 67.043L160.812 112.174C165.021 114.874 169.727 116.736 174.546 118.03H174.556Z",
    stroke: "url(#paint154_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.311 118.229L196.149 90.2935L201.878 45.1836L181.03 73.098L175.311 118.229Z",
    stroke: "url(#paint155_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.03 73.0976L201.868 45.1729C191.516 42.3483 142.642 43.8692 162.932 64.2515C167.596 68.9384 174.773 71.4939 181.03 73.0976Z",
    stroke: "url(#paint156_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.149 90.292L175.311 118.227C167.782 116.303 152.125 110.829 152.777 100.638C153.428 90.4472 168.124 88.6263 175.476 88.1607C182.385 87.7261 189.479 88.4607 196.149 90.292Z",
    stroke: "url(#paint157_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.311 118.229C187.049 121.24 202.168 122.192 212.965 115.663L218.694 70.543C207.897 77.0715 192.767 76.1093 181.03 73.1089L175.311 118.24V118.229Z",
    stroke: "url(#paint158_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.149 90.2935L175.311 118.229L181.03 73.098L201.878 45.1836L196.149 90.2935Z",
    stroke: "url(#paint159_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.384 100.431L215.012 100.028L220.741 54.918C225.809 59.9773 224.847 66.9507 218.694 70.5409L212.964 115.661C218.838 112.216 220.173 105.48 215.384 100.431V100.431Z",
    stroke: "url(#paint160_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.012 100.029C210.048 94.908 202.964 91.9593 196.149 90.2935L201.878 45.1836C208.693 46.8494 215.788 49.7981 220.752 54.9195L215.023 100.029H215.012Z",
    stroke: "url(#paint161_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.741 54.9195C215.777 49.8084 208.683 46.8597 201.868 45.1836L181.03 73.1083C191.857 75.8811 205.953 77.0503 216.294 71.8461C223.296 68.318 227.194 61.3549 220.741 54.9298V54.9195Z",
    stroke: "url(#paint162_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.671 99.6667C221.331 105.999 217.959 113.096 210.824 116.831C200.513 122.232 186.17 121.001 175.311 118.228L196.149 90.293C202.83 91.9277 209.697 94.7936 214.671 99.6667V99.6667Z",
    stroke: "url(#paint163_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2664 265.754C77.0144 268.744 92.113 269.665 102.91 263.126L108.628 217.902C97.8319 224.441 82.7332 223.52 70.9852 220.53L65.2767 265.764L65.2664 265.754Z",
    stroke: "url(#paint164_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2597 237.613L65.2664 265.755L70.9749 220.531L91.9682 192.41L86.2597 237.613Z",
    stroke: "url(#paint165_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.361 247.804L104.988 247.401L110.707 202.188C115.795 207.288 114.792 214.293 108.618 217.904L102.899 263.127C108.794 259.661 110.159 252.905 105.361 247.804V247.804Z",
    stroke: "url(#paint166_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.999 247.401C100.055 242.279 93.0335 239.393 86.2598 237.624L91.9786 192.41C98.7524 194.179 105.774 197.066 110.728 202.187L105.009 247.401H104.999Z",
    stroke: "url(#paint167_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.717 202.176C105.764 197.054 98.7523 194.168 91.9682 192.398L70.9749 220.52C81.8025 223.272 95.8773 224.41 106.209 219.195C113.241 215.647 117.171 208.653 110.707 202.176H110.717Z",
    stroke: "url(#paint168_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.616 246.997C111.328 253.371 107.946 260.53 100.748 264.307C90.4377 269.708 76.1146 268.518 65.2664 265.755L86.2597 237.613C92.8887 239.351 99.6624 242.135 104.616 246.997V246.997Z",
    stroke: "url(#paint169_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2664 265.754C77.0144 268.744 92.113 269.665 102.91 263.126L108.628 217.902C97.8319 224.441 82.7332 223.52 70.9852 220.53L65.2767 265.764L65.2664 265.754Z",
    stroke: "url(#paint170_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2597 237.613L65.2664 265.755L70.9749 220.531L91.9682 192.41L86.2597 237.613Z",
    stroke: "url(#paint171_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.361 247.804L104.988 247.401L110.707 202.188C115.795 207.288 114.792 214.293 108.618 217.904L102.899 263.127C108.794 259.661 110.159 252.905 105.361 247.804V247.804Z",
    stroke: "url(#paint172_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.999 247.401C100.055 242.279 93.0335 239.393 86.2598 237.624L91.9786 192.41C98.7524 194.179 105.774 197.066 110.728 202.187L105.009 247.401H104.999Z",
    stroke: "url(#paint173_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.717 202.176C105.764 197.054 98.7523 194.168 91.9682 192.398L70.9749 220.52C81.8025 223.272 95.8773 224.41 106.209 219.195C113.241 215.647 117.171 208.653 110.707 202.176H110.717Z",
    stroke: "url(#paint174_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.616 246.997C111.328 253.371 107.946 260.53 100.748 264.307C90.4377 269.708 76.1146 268.518 65.2664 265.755L86.2597 237.613C92.8887 239.351 99.6624 242.135 104.616 246.997V246.997Z",
    stroke: "url(#paint175_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2664 265.754C77.0144 268.744 92.113 269.665 102.91 263.126L108.628 217.902C97.8319 224.441 82.7332 223.52 70.9852 220.53L65.2767 265.764L65.2664 265.754Z",
    stroke: "url(#paint176_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2597 237.613L65.2664 265.755L70.9749 220.531L91.9682 192.41L86.2597 237.613Z",
    stroke: "url(#paint177_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.361 247.804L104.988 247.401L110.707 202.188C115.795 207.288 114.792 214.293 108.618 217.904L102.899 263.127C108.794 259.661 110.159 252.905 105.361 247.804V247.804Z",
    stroke: "url(#paint178_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.999 247.401C100.055 242.279 93.0335 239.393 86.2598 237.624L91.9786 192.41C98.7524 194.179 105.774 197.066 110.728 202.187L105.009 247.401H104.999Z",
    stroke: "url(#paint179_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.717 202.176C105.764 197.054 98.7523 194.168 91.9682 192.398L70.9749 220.52C81.8025 223.272 95.8773 224.41 106.209 219.195C113.241 215.647 117.171 208.653 110.707 202.176H110.717Z",
    stroke: "url(#paint180_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.616 246.997C111.328 253.371 107.946 260.53 100.748 264.307C90.4377 269.708 76.1146 268.518 65.2664 265.755L86.2597 237.613C92.8887 239.351 99.6624 242.135 104.616 246.997V246.997Z",
    stroke: "url(#paint181_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2664 265.754C77.0144 268.744 92.113 269.665 102.91 263.126L108.628 217.902C97.8319 224.441 82.7332 223.52 70.9852 220.53L65.2767 265.764L65.2664 265.754Z",
    stroke: "url(#paint182_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2597 237.613L65.2664 265.755L70.9749 220.531L91.9682 192.41L86.2597 237.613Z",
    stroke: "url(#paint183_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.361 247.804L104.988 247.401L110.707 202.188C115.795 207.288 114.792 214.293 108.618 217.904L102.899 263.127C108.794 259.661 110.159 252.905 105.361 247.804V247.804Z",
    stroke: "url(#paint184_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.999 247.401C100.055 242.279 93.0335 239.393 86.2598 237.624L91.9786 192.41C98.7524 194.179 105.774 197.066 110.728 202.187L105.009 247.401H104.999Z",
    stroke: "url(#paint185_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.717 202.176C105.764 197.054 98.7523 194.168 91.9682 192.398L70.9749 220.52C81.8025 223.272 95.8773 224.41 106.209 219.195C113.241 215.647 117.171 208.653 110.707 202.176H110.717Z",
    stroke: "url(#paint186_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.616 246.997C111.328 253.371 107.946 260.53 100.748 264.307C90.4377 269.708 76.1146 268.518 65.2664 265.755L86.2597 237.613C92.8887 239.351 99.6624 242.135 104.616 246.997V246.997Z",
    stroke: "url(#paint187_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2664 265.754C77.0144 268.744 92.113 269.665 102.91 263.126L108.628 217.902C97.8319 224.441 82.7332 223.52 70.9852 220.53L65.2767 265.764L65.2664 265.754Z",
    stroke: "url(#paint188_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2597 237.613L65.2664 265.755L70.9749 220.531L91.9682 192.41L86.2597 237.613Z",
    stroke: "url(#paint189_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.361 247.804L104.988 247.401L110.707 202.188C115.795 207.288 114.792 214.293 108.618 217.904L102.899 263.127C108.794 259.661 110.159 252.905 105.361 247.804V247.804Z",
    stroke: "url(#paint190_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.999 247.401C100.055 242.279 93.0335 239.393 86.2598 237.624L91.9786 192.41C98.7524 194.179 105.774 197.066 110.728 202.187L105.009 247.401H104.999Z",
    stroke: "url(#paint191_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.717 202.176C105.764 197.054 98.7523 194.168 91.9682 192.398L70.9749 220.52C81.8025 223.272 95.8773 224.41 106.209 219.195C113.241 215.647 117.171 208.653 110.707 202.176H110.717Z",
    stroke: "url(#paint192_linear_3508_3639)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.616 246.997C111.328 253.371 107.946 260.53 100.748 264.307C90.4377 269.708 76.1146 268.518 65.2664 265.755L86.2597 237.613C92.8887 239.351 99.6624 242.135 104.616 246.997V246.997Z",
    stroke: "url(#paint193_linear_3508_3639)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3508_3639",
    x1: 61.802,
    y1: 91.1205,
    x2: 181.568,
    y2: 91.1205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3508_3639",
    x1: -9.0894,
    y1: 152.382,
    x2: 92.0407,
    y2: 152.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3508_3639",
    x1: 41.9772,
    y1: 227.889,
    x2: 92.0407,
    y2: 227.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3508_3639",
    x1: -75.9785,
    y1: 174.379,
    x2: 71.5334,
    y2: 174.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3508_3639",
    x1: -66.547,
    y1: 81.3345,
    x2: 199.779,
    y2: 81.3345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3508_3639",
    x1: 152.239,
    y1: 80.6943,
    x2: 197.018,
    y2: 80.6943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3508_3639",
    x1: 190.151,
    y1: 66.7966,
    x2: 199.779,
    y2: 66.7966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3508_3639",
    x1: -69.8563,
    y1: 125.834,
    x2: 199.334,
    y2: 125.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3508_3639",
    x1: -75.5132,
    y1: 171.266,
    x2: 193.615,
    y2: 171.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3508_3639",
    x1: 61.802,
    y1: 91.1205,
    x2: 181.568,
    y2: 91.1205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3508_3639",
    x1: -9.0894,
    y1: 152.382,
    x2: 92.0407,
    y2: 152.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3508_3639",
    x1: 41.9772,
    y1: 227.889,
    x2: 92.0407,
    y2: 227.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3508_3639",
    x1: -75.9785,
    y1: 174.379,
    x2: 71.5334,
    y2: 174.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3508_3639",
    x1: -66.547,
    y1: 81.3345,
    x2: 199.779,
    y2: 81.3345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3508_3639",
    x1: 152.239,
    y1: 80.6943,
    x2: 197.018,
    y2: 80.6943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3508_3639",
    x1: 190.151,
    y1: 66.7966,
    x2: 199.779,
    y2: 66.7966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3508_3639",
    x1: -69.8563,
    y1: 125.834,
    x2: 199.334,
    y2: 125.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3508_3639",
    x1: -75.5132,
    y1: 171.266,
    x2: 193.615,
    y2: 171.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3508_3639",
    x1: 61.802,
    y1: 91.1205,
    x2: 181.568,
    y2: 91.1205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3508_3639",
    x1: -9.0894,
    y1: 152.382,
    x2: 92.0407,
    y2: 152.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3508_3639",
    x1: 41.9772,
    y1: 227.889,
    x2: 92.0407,
    y2: 227.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3508_3639",
    x1: -75.9785,
    y1: 174.379,
    x2: 71.5334,
    y2: 174.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3508_3639",
    x1: -66.547,
    y1: 81.3345,
    x2: 199.779,
    y2: 81.3345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3508_3639",
    x1: 152.239,
    y1: 80.6943,
    x2: 197.018,
    y2: 80.6943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3508_3639",
    x1: 190.151,
    y1: 66.7966,
    x2: 199.779,
    y2: 66.7966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3508_3639",
    x1: -69.8563,
    y1: 125.834,
    x2: 199.334,
    y2: 125.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3508_3639",
    x1: -75.5132,
    y1: 171.266,
    x2: 193.615,
    y2: 171.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3508_3639",
    x1: 61.802,
    y1: 91.1205,
    x2: 181.568,
    y2: 91.1205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3508_3639",
    x1: -9.0894,
    y1: 152.382,
    x2: 92.0407,
    y2: 152.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3508_3639",
    x1: 41.9772,
    y1: 227.889,
    x2: 92.0407,
    y2: 227.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3508_3639",
    x1: -75.9785,
    y1: 174.379,
    x2: 71.5334,
    y2: 174.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3508_3639",
    x1: -66.547,
    y1: 81.3345,
    x2: 199.779,
    y2: 81.3345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3508_3639",
    x1: 152.239,
    y1: 80.6943,
    x2: 197.018,
    y2: 80.6943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3508_3639",
    x1: -69.8563,
    y1: 125.834,
    x2: 199.334,
    y2: 125.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3508_3639",
    x1: -75.5132,
    y1: 171.266,
    x2: 193.615,
    y2: 171.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3508_3639",
    x1: 64.6976,
    y1: 231.088,
    x2: 332.502,
    y2: 231.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3508_3639",
    x1: 64.6976,
    y1: 230.237,
    x2: 114.699,
    y2: 230.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3508_3639",
    x1: 85.8254,
    y1: 219.632,
    x2: 205.725,
    y2: 219.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3508_3639",
    x1: 174.742,
    y1: 158.289,
    x2: 277.082,
    y2: 158.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3508_3639",
    x1: 174.742,
    y1: 83.1149,
    x2: 224.34,
    y2: 83.1149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3508_3639",
    x1: 314.301,
    y1: 167.913,
    x2: 342.368,
    y2: 167.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3508_3639",
    x1: 197.918,
    y1: 98.9848,
    x2: 321.158,
    y2: 98.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3508_3639",
    x1: 70.8404,
    y1: 140.07,
    x2: 342.772,
    y2: 140.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3508_3639",
    x1: 65.1319,
    y1: 185.191,
    x2: 337.084,
    y2: 185.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3508_3639",
    x1: 64.6976,
    y1: 231.088,
    x2: 332.502,
    y2: 231.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3508_3639",
    x1: 64.6976,
    y1: 230.237,
    x2: 114.699,
    y2: 230.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3508_3639",
    x1: 85.8254,
    y1: 219.632,
    x2: 205.725,
    y2: 219.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3508_3639",
    x1: 174.742,
    y1: 158.289,
    x2: 277.082,
    y2: 158.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3508_3639",
    x1: 174.742,
    y1: 83.1149,
    x2: 224.34,
    y2: 83.1149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3508_3639",
    x1: 314.301,
    y1: 167.913,
    x2: 342.368,
    y2: 167.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3508_3639",
    x1: 197.918,
    y1: 98.9848,
    x2: 321.158,
    y2: 98.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3508_3639",
    x1: 70.8404,
    y1: 140.07,
    x2: 342.772,
    y2: 140.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3508_3639",
    x1: 65.1319,
    y1: 185.191,
    x2: 337.084,
    y2: 185.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3508_3639",
    x1: 64.6976,
    y1: 231.088,
    x2: 332.502,
    y2: 231.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_3508_3639",
    x1: 64.6976,
    y1: 230.237,
    x2: 114.699,
    y2: 230.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3508_3639",
    x1: 85.8254,
    y1: 219.632,
    x2: 205.725,
    y2: 219.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_3508_3639",
    x1: 174.742,
    y1: 158.289,
    x2: 277.082,
    y2: 158.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3508_3639",
    x1: 174.742,
    y1: 83.1149,
    x2: 224.34,
    y2: 83.1149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_3508_3639",
    x1: 314.301,
    y1: 167.913,
    x2: 342.368,
    y2: 167.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3508_3639",
    x1: 197.918,
    y1: 98.9848,
    x2: 321.158,
    y2: 98.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3508_3639",
    x1: 70.8404,
    y1: 140.07,
    x2: 342.772,
    y2: 140.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3508_3639",
    x1: 65.1319,
    y1: 185.191,
    x2: 337.084,
    y2: 185.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3508_3639",
    x1: 64.6976,
    y1: 231.088,
    x2: 332.502,
    y2: 231.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_3508_3639",
    x1: 64.6976,
    y1: 230.237,
    x2: 114.699,
    y2: 230.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_3508_3639",
    x1: 85.8254,
    y1: 219.632,
    x2: 205.725,
    y2: 219.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_3508_3639",
    x1: 174.742,
    y1: 158.289,
    x2: 277.082,
    y2: 158.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_3508_3639",
    x1: 174.742,
    y1: 83.1149,
    x2: 224.34,
    y2: 83.1149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_3508_3639",
    x1: 314.301,
    y1: 167.913,
    x2: 342.368,
    y2: 167.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_3508_3639",
    x1: 197.918,
    y1: 98.9848,
    x2: 321.158,
    y2: 98.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_3508_3639",
    x1: 70.8404,
    y1: 140.07,
    x2: 342.772,
    y2: 140.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_3508_3639",
    x1: 65.1319,
    y1: 185.191,
    x2: 337.084,
    y2: 185.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_3508_3639",
    x1: -106.724,
    y1: 239.85,
    x2: 262.925,
    y2: 239.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_3508_3639",
    x1: -137.904,
    y1: 110.77,
    x2: 18.0262,
    y2: 110.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_3508_3639",
    x1: 255.965,
    y1: 202.973,
    x2: 404.666,
    y2: 202.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_3508_3639",
    x1: 11.1594,
    y1: 74.2889,
    x2: 379.701,
    y2: 74.2889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_3508_3639",
    x1: -75.5029,
    y1: 168.862,
    x2: 127.533,
    y2: 168.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_3508_3639",
    x1: -42.2237,
    y1: 90.719,
    x2: 318.934,
    y2: 90.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_3508_3639",
    x1: 120.645,
    y1: 191.511,
    x2: 342.865,
    y2: 191.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_3508_3639",
    x1: -130.923,
    y1: 132.775,
    x2: 406,
    y2: 132.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_3508_3639",
    x1: -139,
    y1: 178.352,
    x2: 398.058,
    y2: 178.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_3508_3639",
    x1: -70.5182,
    y1: 133.106,
    x2: 342.503,
    y2: 133.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_3508_3639",
    x1: -75.6993,
    y1: 177.978,
    x2: 337.539,
    y2: 177.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_3508_3639",
    x1: -106.724,
    y1: 239.85,
    x2: 262.925,
    y2: 239.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_3508_3639",
    x1: -137.904,
    y1: 110.77,
    x2: 18.0262,
    y2: 110.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_3508_3639",
    x1: 255.965,
    y1: 202.973,
    x2: 404.666,
    y2: 202.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_3508_3639",
    x1: 11.1594,
    y1: 74.2889,
    x2: 379.701,
    y2: 74.2889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_3508_3639",
    x1: -75.5029,
    y1: 168.862,
    x2: 127.533,
    y2: 168.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_3508_3639",
    x1: -42.2237,
    y1: 90.719,
    x2: 318.934,
    y2: 90.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_3508_3639",
    x1: 120.645,
    y1: 191.511,
    x2: 342.865,
    y2: 191.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_3508_3639",
    x1: -130.923,
    y1: 132.775,
    x2: 406,
    y2: 132.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_3508_3639",
    x1: -139,
    y1: 178.352,
    x2: 398.058,
    y2: 178.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_3508_3639",
    x1: -70.5182,
    y1: 133.106,
    x2: 342.503,
    y2: 133.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_3508_3639",
    x1: -75.6993,
    y1: 177.978,
    x2: 337.539,
    y2: 177.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_3508_3639",
    x1: -106.724,
    y1: 239.85,
    x2: 262.925,
    y2: 239.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_3508_3639",
    x1: -137.904,
    y1: 110.77,
    x2: 18.0262,
    y2: 110.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_3508_3639",
    x1: 255.965,
    y1: 202.973,
    x2: 404.666,
    y2: 202.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_3508_3639",
    x1: 11.1594,
    y1: 74.2889,
    x2: 379.701,
    y2: 74.2889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_3508_3639",
    x1: -75.5029,
    y1: 168.862,
    x2: 127.533,
    y2: 168.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_3508_3639",
    x1: -42.2237,
    y1: 90.719,
    x2: 318.934,
    y2: 90.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_3508_3639",
    x1: 120.645,
    y1: 191.511,
    x2: 342.865,
    y2: 191.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_3508_3639",
    x1: -130.923,
    y1: 132.775,
    x2: 406,
    y2: 132.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_3508_3639",
    x1: -139,
    y1: 178.352,
    x2: 398.058,
    y2: 178.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_3508_3639",
    x1: -70.5182,
    y1: 133.106,
    x2: 342.503,
    y2: 133.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_3508_3639",
    x1: -75.6993,
    y1: 177.978,
    x2: 337.539,
    y2: 177.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_3508_3639",
    x1: 4.93377,
    y1: 198.393,
    x2: 202.664,
    y2: 198.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_3508_3639",
    x1: -9.31693,
    y1: 131.287,
    x2: 74.8633,
    y2: 131.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_3508_3639",
    x1: 195.715,
    y1: 179.996,
    x2: 276.689,
    y2: 179.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_3508_3639",
    x1: 67.9759,
    y1: 113.045,
    x2: 263.804,
    y2: 113.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_3508_3639",
    x1: -4.25991,
    y1: 132.984,
    x2: 276.989,
    y2: 132.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_3508_3639",
    x1: -9.75126,
    y1: 178.287,
    x2: 270.184,
    y2: 178.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_3508_3639",
    x1: 4.93377,
    y1: 198.393,
    x2: 202.664,
    y2: 198.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_3508_3639",
    x1: -9.31693,
    y1: 131.287,
    x2: 74.8633,
    y2: 131.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_3508_3639",
    x1: 195.715,
    y1: 179.996,
    x2: 276.689,
    y2: 179.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_3508_3639",
    x1: 67.9759,
    y1: 113.045,
    x2: 263.804,
    y2: 113.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_3508_3639",
    x1: -4.25991,
    y1: 132.984,
    x2: 276.989,
    y2: 132.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_3508_3639",
    x1: -9.75126,
    y1: 178.287,
    x2: 270.184,
    y2: 178.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_3508_3639",
    x1: 4.93377,
    y1: 198.393,
    x2: 202.664,
    y2: 198.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_3508_3639",
    x1: -9.31693,
    y1: 131.287,
    x2: 74.8633,
    y2: 131.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_3508_3639",
    x1: 195.715,
    y1: 179.996,
    x2: 276.689,
    y2: 179.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_3508_3639",
    x1: 67.9759,
    y1: 113.045,
    x2: 263.804,
    y2: 113.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_3508_3639",
    x1: -4.25991,
    y1: 132.984,
    x2: 276.989,
    y2: 132.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_3508_3639",
    x1: -9.75126,
    y1: 178.287,
    x2: 270.184,
    y2: 178.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_3508_3639",
    x1: 42.3496,
    y1: 226.927,
    x2: 56.3624,
    y2: 226.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_3508_3639",
    x1: 47.8926,
    y1: 215.121,
    x2: 92.5371,
    y2: 215.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_3508_3639",
    x1: 49.5473,
    y1: 239.798,
    x2: 71.5438,
    y2: 239.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_3508_3639",
    x1: 64.5012,
    y1: 229.077,
    x2: 92.7336,
    y2: 229.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_3508_3639",
    x1: 47.2618,
    y1: 205.993,
    x2: 92.8474,
    y2: 205.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_3508_3639",
    x1: 42.0186,
    y1: 250.589,
    x2: 87.1285,
    y2: 250.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_3508_3639",
    x1: 42.3496,
    y1: 226.927,
    x2: 56.3624,
    y2: 226.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_3508_3639",
    x1: 47.8926,
    y1: 215.121,
    x2: 92.5371,
    y2: 215.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_3508_3639",
    x1: 49.5473,
    y1: 239.798,
    x2: 71.5438,
    y2: 239.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_3508_3639",
    x1: 64.5012,
    y1: 229.077,
    x2: 92.7336,
    y2: 229.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_3508_3639",
    x1: 47.2618,
    y1: 205.993,
    x2: 92.8474,
    y2: 205.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_3508_3639",
    x1: 42.0186,
    y1: 250.589,
    x2: 87.1285,
    y2: 250.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_3508_3639",
    x1: 42.3496,
    y1: 226.927,
    x2: 56.3624,
    y2: 226.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_3508_3639",
    x1: 47.8926,
    y1: 215.121,
    x2: 92.5371,
    y2: 215.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_3508_3639",
    x1: 49.5473,
    y1: 239.798,
    x2: 71.5438,
    y2: 239.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_3508_3639",
    x1: 64.5012,
    y1: 229.077,
    x2: 92.7336,
    y2: 229.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_3508_3639",
    x1: 47.2618,
    y1: 205.993,
    x2: 92.8474,
    y2: 205.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_3508_3639",
    x1: 42.0186,
    y1: 250.589,
    x2: 87.1285,
    y2: 250.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_3508_3639",
    x1: 42.3496,
    y1: 226.927,
    x2: 56.3624,
    y2: 226.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_3508_3639",
    x1: 47.8926,
    y1: 215.121,
    x2: 92.5371,
    y2: 215.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_3508_3639",
    x1: 49.5473,
    y1: 239.798,
    x2: 71.5438,
    y2: 239.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_3508_3639",
    x1: 64.5012,
    y1: 229.077,
    x2: 92.7336,
    y2: 229.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_3508_3639",
    x1: 47.2618,
    y1: 205.993,
    x2: 92.8474,
    y2: 205.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_3508_3639",
    x1: 42.0186,
    y1: 250.589,
    x2: 87.1285,
    y2: 250.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_3508_3639",
    x1: 42.3496,
    y1: 226.927,
    x2: 56.3624,
    y2: 226.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_3508_3639",
    x1: 47.8926,
    y1: 215.121,
    x2: 92.5371,
    y2: 215.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_3508_3639",
    x1: 49.5473,
    y1: 239.798,
    x2: 71.5438,
    y2: 239.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_3508_3639",
    x1: 64.5012,
    y1: 229.077,
    x2: 92.7336,
    y2: 229.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_3508_3639",
    x1: 47.2618,
    y1: 205.993,
    x2: 92.8474,
    y2: 205.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_3508_3639",
    x1: 42.0186,
    y1: 250.589,
    x2: 87.1285,
    y2: 250.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_3508_3639",
    x1: 152.539,
    y1: 79.8513,
    x2: 167.1,
    y2: 79.8513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_3508_3639",
    x1: 157.637,
    y1: 67.9852,
    x2: 202.447,
    y2: 67.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_3508_3639",
    x1: 160.274,
    y1: 92.5259,
    x2: 181.599,
    y2: 92.5259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_3508_3639",
    x1: 174.546,
    y1: 81.7061,
    x2: 202.633,
    y2: 81.7061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_3508_3639",
    x1: 157.544,
    y1: 58.6334,
    x2: 202.747,
    y2: 58.6334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_3508_3639",
    x1: 152.239,
    y1: 103.173,
    x2: 197.018,
    y2: 103.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_3508_3639",
    x1: 174.742,
    y1: 95.3121,
    x2: 219.345,
    y2: 95.3121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_3508_3639",
    x1: 174.546,
    y1: 81.7061,
    x2: 202.633,
    y2: 81.7061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_3508_3639",
    x1: 212.313,
    y1: 85.2223,
    x2: 224.526,
    y2: 85.2223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_3508_3639",
    x1: 195.58,
    y1: 72.8497,
    x2: 221.29,
    y2: 72.8497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_3508_3639",
    x1: 180.151,
    y1: 60.2892,
    x2: 224.547,
    y2: 60.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_3508_3639",
    x1: 174.432,
    y1: 105.409,
    x2: 218.776,
    y2: 105.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_3508_3639",
    x1: 64.6976,
    y1: 242.734,
    x2: 109.27,
    y2: 242.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_3508_3639",
    x1: 64.5011,
    y1: 229.077,
    x2: 92.7335,
    y2: 229.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_3508_3639",
    x1: 102.258,
    y1: 232.585,
    x2: 114.492,
    y2: 232.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_3508_3639",
    x1: 85.6806,
    y1: 220.149,
    x2: 111.255,
    y2: 220.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_3508_3639",
    x1: 70.0958,
    y1: 207.597,
    x2: 114.513,
    y2: 207.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_3508_3639",
    x1: 64.3873,
    y1: 252.822,
    x2: 108.753,
    y2: 252.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_3508_3639",
    x1: 64.6976,
    y1: 242.734,
    x2: 109.27,
    y2: 242.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_3508_3639",
    x1: 64.5011,
    y1: 229.077,
    x2: 92.7335,
    y2: 229.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_3508_3639",
    x1: 102.258,
    y1: 232.585,
    x2: 114.492,
    y2: 232.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_3508_3639",
    x1: 85.6806,
    y1: 220.149,
    x2: 111.255,
    y2: 220.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_3508_3639",
    x1: 70.0958,
    y1: 207.597,
    x2: 114.513,
    y2: 207.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_3508_3639",
    x1: 64.3873,
    y1: 252.822,
    x2: 108.753,
    y2: 252.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_3508_3639",
    x1: 64.6976,
    y1: 242.734,
    x2: 109.27,
    y2: 242.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_3508_3639",
    x1: 64.5011,
    y1: 229.077,
    x2: 92.7335,
    y2: 229.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_3508_3639",
    x1: 102.258,
    y1: 232.585,
    x2: 114.492,
    y2: 232.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_3508_3639",
    x1: 85.6806,
    y1: 220.149,
    x2: 111.255,
    y2: 220.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_3508_3639",
    x1: 70.0958,
    y1: 207.597,
    x2: 114.513,
    y2: 207.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_3508_3639",
    x1: 64.3873,
    y1: 252.822,
    x2: 108.753,
    y2: 252.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_3508_3639",
    x1: 64.6976,
    y1: 242.734,
    x2: 109.27,
    y2: 242.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_3508_3639",
    x1: 64.5011,
    y1: 229.077,
    x2: 92.7335,
    y2: 229.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_3508_3639",
    x1: 102.258,
    y1: 232.585,
    x2: 114.492,
    y2: 232.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_3508_3639",
    x1: 85.6806,
    y1: 220.149,
    x2: 111.255,
    y2: 220.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_3508_3639",
    x1: 70.0958,
    y1: 207.597,
    x2: 114.513,
    y2: 207.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_3508_3639",
    x1: 64.3873,
    y1: 252.822,
    x2: 108.753,
    y2: 252.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_3508_3639",
    x1: 64.6976,
    y1: 242.734,
    x2: 109.27,
    y2: 242.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_3508_3639",
    x1: 64.5011,
    y1: 229.077,
    x2: 92.7335,
    y2: 229.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_3508_3639",
    x1: 102.258,
    y1: 232.585,
    x2: 114.492,
    y2: 232.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_3508_3639",
    x1: 85.6806,
    y1: 220.149,
    x2: 111.255,
    y2: 220.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_3508_3639",
    x1: 70.0958,
    y1: 207.597,
    x2: 114.513,
    y2: 207.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_3508_3639",
    x1: 64.3873,
    y1: 252.822,
    x2: 108.753,
    y2: 252.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3508_3639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 545,
    height: 311,
    fill: "white",
    transform: "translate(-139)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.af3714ce72b29729d43aeaf000379654.svg";
export { ForwardRef as ReactComponent };